import { render, staticRenderFns } from "./AboutBrief.vue?vue&type=template&id=1f32674d&scoped=true"
import script from "./AboutBrief.vue?vue&type=script&lang=js"
export * from "./AboutBrief.vue?vue&type=script&lang=js"
import style0 from "./AboutBrief.vue?vue&type=style&index=0&id=1f32674d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32674d",
  null
  
)

export default component.exports